import React from 'react';
import Helmet from 'react-helmet';

interface WithMetaDescriptionProps {
  title: string;
}

export const withMetaDescription =
  ({ title }: WithMetaDescriptionProps) =>
  <P extends object>(
    WrappedComponent: React.ComponentType<P>
  ): React.FC<P & WithMetaDescriptionProps> => {
    const ComponentWithMetaDescription = (props: P) => (
      <>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <WrappedComponent {...props} />
      </>
    );
    return ComponentWithMetaDescription;
  };
